module.exports = __webpack_public_path__ + "static/media/users.17f14fcf.svg";